import { PaymentRequestModal } from '@lightspeed/invoicing-library'
import React from 'react'
import ReactDOM from 'react-dom'

interface PaymentRequestModalProps {
  open: boolean
  setOpen: () => void
  saleId?: string
}

export const PaymentRequestModalWrapper: React.FC<PaymentRequestModalProps> = ({
  open,
  setOpen,
  saleId,
}) => {
  const [customerEmail, setCustomerEmail] = React.useState('')

  if (!open) {
    return null
  }

  const paymentRequestDto = {
    requestedAmount: 100,
    sendToEmail: 'test@email.com',
    integrationKey: 'your-integration-key',
    location: {
      locationRef: 'location-ref',
      name: 'Location Name',
      email: 'location@example.com',
    },
    customer: {
      customerRef: 'customer-ref',
      firstName: 'Karen',
      lastName: 'Planas-Pena',
      email: 'test@email.com',
    },
    documentRefs: ['document-ref'],
    registerRef: 'register-ref',
    shopRef: 'shop-ref',
    accountRef: 'account-ref',
    pricingTables: [
      {
        title: 'Default Pricing Table',
        totalAmount: 100,
        subtotal: 100,
        discountTotal: 0,
        feeTotal: 0,
        taxTotal: 0,
        currency: 'USD',
        lineItems: [],
      },
    ],
  }

  return ReactDOM.createPortal(
    <PaymentRequestModal
      open={open}
      setOpen={setOpen}
      customerEmail={customerEmail}
      setCustomerEmail={value => {
        setCustomerEmail(value)
      }}
      documentURL="https://test/url"
      onSubmit={formData => {
        setOpen()
      }}
      handleCancel={setOpen}
      paymentRequestDto={paymentRequestDto}
    />,
    document.body
  )
}
